import Vue from 'vue'
import VueRouter from 'vue-router'
// import axios from 'axios';
import login from '../views/LoginView.vue'
//model 养安馨大首页
import index from '../views/IndexView.vue'
import my from '../views/MyView.vue'
import search from '../views/SearchView.vue'
import zxdetail from '../views/ZxdetailsView.vue'
import protocol from '../views/protocolView.vue'
import PlayerVideo from '../views/PlayerVideo.vue'

// import { gzhCodeGetOpenId} from '@/api/user'
const routes = [
  {
    path: '/login',
    name: 'login',
    component: login,
  },
  {
    path: '/',
    name: 'index',
    component: index,
  },
  {
    path: '/my',
    name: 'my',
    component: my,
  },
  {
    path: '/zxdetail/:data',
    name: 'zxdetail',
    component: zxdetail,
  },
  {
    path: '/protocol/:data',
    name: 'protocol',
    component: protocol,
  },
  {
    path: '/search',
    name: 'search',
    component: search,
  },
  {
    path: '/playervideo/:data',
    name: 'playervideo',
    component: PlayerVideo,
  },

]
const router = new VueRouter({
  // mode: 'history',
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})


// router.beforeEach((to, from, next) => {
//   const publicPages = ['/', '/register', '/email', '/resetPwd', '/tel', '/configresetpwd', '/login'];
//   const authRequired = !publicPages.includes(to.path);
//   const loggedIn = localStorage.getItem('TOKEN');
//   if (authRequired && !loggedIn) {
//     return next('/');
//   }
//   next(); 
// });
// function delCodeandstate(to) { // 函数作用：去除 url 中的 code 和 state
//     let path = "";
//     for (let i in to.query) {
//         if (i !== "code" && i !== "state") {
//             path += `&${i}=${to.query[i]}`;
//         }
//     }
//     path = path ? path.substring(1) : "";
//     path = path ? `/?${path}` : "";
//     return path;
// }
// router.beforeEach((to, from, next) => {
//     let fullPath = to.fullPath;
//     if (to.fullPath.includes("code")) {
//         console.log('触发');
//         fullPath = delCodeandstate(to);
//     }
//     // 检查修改后的 fullPath 是否与当前路径相同，如果不同，则导航到新的路径
//     if (fullPath !== to.fullPath) {
//         next(fullPath);
//     } else {
//         next(); // 如果路径没有改变，继续导航
//     }
// });

Vue.use(VueRouter)
export default router
